export const AddPhoto = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="add"
  >
    <path
      d="M6.5 9.5C7.6 9.5 8.5 8.6 8.5 7.5C8.5 6.4 7.6 5.5 6.5 5.5C5.4 5.5 4.5 6.4 4.5 7.5C4.5 8.6 5.4 9.5 6.5 9.5Z"
      stroke="#707475"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.54 11.17L11.92 10.18C11.83 10.03 11.67 9.95 11.5 9.95C11.33 9.95 11.17 10.04 11.08 10.18L8.44001 14.4L7.36001 12.68C7.27001 12.53 7.11001 12.45 6.94001 12.45C6.77001 12.45 6.61001 12.54 6.52001 12.68L3.51001 17.5H8.51001"
      stroke="#707475"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5 23.5H1.5C0.95 23.5 0.5 23.05 0.5 22.5V1.5C0.5 0.95 0.95 0.5 1.5 0.5H14.79C15.06 0.5 15.31 0.61 15.5 0.79L19.21 4.5C19.4 4.69 19.5 4.94 19.5 5.21V9.5"
      stroke="#707475"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.5 23.5C20.81 23.5 23.5 20.81 23.5 17.5C23.5 14.19 20.81 11.5 17.5 11.5C14.19 11.5 11.5 14.19 11.5 17.5C11.5 20.81 14.19 23.5 17.5 23.5Z"
      stroke="#707475"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M17.5 14.5V20.5" stroke="#707475" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M20.5 17.5H14.5" stroke="#707475" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
